import antdEn from "antd/lib/locale-provider/en_US";

import enMessages from "../locales/en_default.json";
import enTranslatedMessages from "../locales/en_translated.json";

import enDescMessages from "../locales/en_desc_default.json";
import enDescTranslatedMessages from "../locales/en_desc_translated.json";

import d3enUS from "d3-format/locale/en-US";

const EnLang = {
  messages: {
    ...enMessages,
    ...enDescMessages,
    ...enTranslatedMessages,
    ...enDescTranslatedMessages,
  },
  antd: antdEn,
  locale: "en-US",
  moment: "en",
  numeral: "en",
  d3: d3enUS,
  label: "English",
  app: "en",
};
export default EnLang;
